import HelpForm from '../forms/HelpForm';
import { useTranslation } from 'react-i18next';
import { FormPage } from './FormPage';
import { useState } from 'react';
import { Link } from 'react-router-dom';

const HelpPage = () => {
  const { t } = useTranslation();
  const [sended, setSended] = useState<boolean>(false);
  return sended ? (
    <div className="text-center flex items-center justify-center">
      <div>
        <h2>{t('mail sended')}</h2>
        <div className="my-10">
          <Link to="/">{t('back to home')}</Link>
        </div>
      </div>
    </div>
  ) : (
    <FormPage
      title={t('help page title')}
      subtitle={t('help page description')}
      component={<HelpForm setSended={setSended} />}
    />
  );
};

export default HelpPage;
